import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n"; // Init i18next avant le rendu React
import { LanguageProvider } from "./contexts/LanguageContext.tsx";
import { Agentation } from "agentation";

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [
      // browserTracingIntegration désactivé : génère trop de spans pour le plan gratuit
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "Non-Error promise rejection captured",
      "Load failed",
      // React Query cancels in-flight requests on component unmount — expected behavior
      "AbortError",
      "signal is aborted without reason",
      "The user aborted a request",
      // Unhandled rejection from same abort pattern
      /^Rejected$/,
    ],
  });
}

createRoot(document.getElementById("root")!).render(
  <LanguageProvider>
    <App />
    {import.meta.env.DEV && <Agentation />}
  </LanguageProvider>
);
